import { ApolloError } from '@apollo/client'
import { GetProjectTimeRangesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface projectTimeRangeDto {
  projectId: string
}

export interface iProjectTimeRange {
  estimatedStartDate?: string | null | undefined
  estimatedDueDate?: string | null | undefined
  realStartDate?: string | null | undefined
  realDueDate?: string | null | undefined
}

export const useGetProjectTimeRanges = ({
  projectId,
}: projectTimeRangeDto): {
  loadingQuery: boolean
  errorQuery: ApolloError | undefined
  projectTimeRanges: iProjectTimeRange[]
} => {
  const { loading, error, data } = useQuery(GetProjectTimeRangesDocument, {
    variables: { projectId },
  })

  return {
    loadingQuery: loading && !data, // Using cache!
    errorQuery: error,
    projectTimeRanges: data ? data.projectManagement.projectTimeRanges : [],
  }
}
